import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the blockchainNetwork table view.
 * @extends JetView
 */
export default class tableCryptoBlockchainView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: _('Acciones'), // Column header
                                    width: 100, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        let content = '';

                                        if (devConfig.getPermAction('cryptoNetworksView', 'Edit')) {
                                            content += "<span class='webix_icon wxi-search view' style='margin-right:8px; cursor:pointer;'></span>";
                                        }

                                        if (devConfig.getPermAction('cryptoNetworksEdit', 'Edit')) {
                                            content += "<span class='webix_icon wxi-close edit'></span>";
                                        }

                                        // If there's at least one icon, we center the container.
                                        if (content) {
                                            return "<div style='display:flex; justify-content:center; align-items:center; height:100%'>" + content + "</div>";
                                        } else {
                                            return '';
                                        }
                                    }
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 55, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'NameCryptoCurrency', // Column ID
                                    header: _('Criptomoneda'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'NameBlockchainNetwork', // Column ID
                                    header: _('Red Blockchain'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'RedBlockchainCode', // Column ID
                                    header: _('Código de Red'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activa') },
                                        { id: 'I', value: _('Inactiva') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sort type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    $$("editform").setValues(item); // Set form values to the clicked item
                                    $$('editwinCryptoBlockchain').show(); // Show edit window on click
                                },
                                view: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    $$("viewform").setValues(item); // Set form values to the clicked item
                                    $$('viewwinCryptoBlockchain').show(); // Show edit window on click
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            url:
                                devConfig.geturlApi() +
                                'CryptoNetworks/GetBlockchainCryptoCurrency',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and binds events.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'CryptoNetworks/GetBlockchainCryptoCurrency'; // API URL for fetching blockchainNetworks
        var filter = ''; // Filter string for data loading
        var popup = webix.ui({
            // Popup window for editing providers
            view: 'window',
            id: 'editwinCryptoBlockchain', // ID for the edit window
            autowidth: screen.width < 500 ? 350 : 450, // Width based on screen size
            minHeight: screen.width < 500 ? 350 : 250, // Height based on screen size
            autoheight: true, // Auto height based on content
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Formulario de Edición Cripto + Red') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            position: 'center', // Center position of the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for editing banblockchainNetwork details
                    id: 'editform', // ID for the edit form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for ID
                            label: 'Id',
                            name: 'Id',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                        },
                        {
                            view: 'text', // Text input for Product
                            label: _('Criptomoneda'),
                            name: 'NameCryptoCurrency',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                        },
                        {
                            view: 'text', // Text input for blockchain ID
                            label: _('Red Blockchain'),
                            name: 'NameBlockchainNetwork',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                        },
                        {
                            view: 'combo', // Combo box for activation status
                            label: _('Estado'),
                            name: 'State',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activa') },
                                { id: 'I', value: _('Inactiva') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                            required: true, // Required field
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide window on click
                                        $$('editform').setValues(
                                            $$('editform').getCleanValues(), // Reset form values
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        var values = $$('editform').getValues(); // Get form values
                                        var form = $$('editform');

                                        if (!form.validate()) {
                                            webix.message({ type: "error", text: _("Por favor, completa todos los campos obligatorios.") });
                                            return;
                                        }
                                        webix
                                            .ajax() // AJAX request to save changes
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'CryptoNetworks/UpdateCryptoNetworks',
                                                '{"Id":' +
                                                values.Id +
                                                ',"State":"' +
                                                values.State +
                                                '","BlockchainIdNetwork":"' +
                                                values.BlockchainIdNetwork +
                                                '","CryptoCurrencyId":"' +
                                                values.CryptoCurrencyId +
                                                '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Criptomoneda a Red Blockchain Editada', // Success message
                                                        );
                                                        grid.clearAll(); // Clear grid data
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    },
                                                },
                                            );
                                        $$('editform').setValues(
                                            $$('editform').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Hide window after saving
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var popupView = webix.ui({
            // Popup window for editing providers
            view: 'window',
            id: 'viewwinCryptoBlockchain', // ID for the edit window
            autowidth: screen.width < 500 ? 350 : 450, // Width based on screen size
            minHeight: screen.width < 500 ? 350 : 250, // Height based on screen size
            autoheight: true, // Auto height based on content
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Visualización Cripto + Red') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            position: 'center', // Center position of the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for editing banblockchainNetwork details
                    id: 'viewform', // ID for the edit form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for ID
                            label: 'Id',
                            name: 'Id',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                        },
                        {
                            view: 'text', // Text input for Product
                            label: _('Criptomoneda'),
                            name: 'NameCryptoCurrency',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                        },
                        {
                            view: 'text', // Text input for blockchain ID
                            label: _('Red Blockchain'),
                            name: 'NameBlockchainNetwork',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                        },
                        {
                            view: 'combo', // Combo box for activation status
                            label: _('Estado'),
                            name: 'State',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                            readonly: true,
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activa') },
                                { id: 'I', value: _('Inactiva') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cerrar'),
                                    click: function () {
                                        // Cancel button click event
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var popupAdd = webix.ui({
            // Popup window for adding blockchainNetworks
            view: 'window',
            id: 'AddCryptoBlockchain', // ID for the add window
            autowidth: screen.width < 500 ? 350 : 450, // Width based on screen size
            minHeight: screen.width < 500 ? 350 : 200, // Height based on screen size
            autoheight: true, // Auto height based on content
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    {
                        view: 'label',
                        label: _('Formulario de Asociación Cripto + Red'), // Label for the window
                    },
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            position: 'center', // Center position of the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for adding blockchainNetwork details
                    id: 'addformPB', // ID for the add form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    elements: [
                        {
                            view: 'combo', // Combo box for product selection
                            name: 'CryptoCurrencyId',
                            localId: 'cryptoCurrencyId:combo',
                            label: _('Criptomonedas'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                            required: true, // Required field
                            placeholder: _(
                                _('Digita para seleccionar '), // Placeholder text
                            ),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed function for product options
                                        var vthis = this;
                                        if (text.length <= 2) {
                                            vthis.clearAll();
                                            return;
                                        }
                                        if (text.length > 2) {
                                            // Fetch data if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GetCryptoSummary',
                                                    '{"Filter":"' + text + '", "State": 1}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text); // Parse response
                                                            if (!resp.HasError) {
                                                                vthis.clearAll();
                                                                vthis.parse(
                                                                    resp.Data, // Parse data into combo
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo', // Combo box for blockchain network selection
                            name: 'BlockchainIdNetwork',
                            localId: 'blockchainIdNetwork:combo',
                            label: _('Red Blockchain'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                            required: true, // Required field
                            placeholder: _(
                                _('Digita para seleccionar '), // Placeholder text
                            ),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed function for blockchain network options
                                        var vthis = this;
                                        if (text.length <= 2) {
                                            vthis.clearAll();
                                            return;
                                        }
                                        if (text.length > 2) {
                                            // Fetch data if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BlockChainSelect',
                                                    '{"Filter":"' + text + '", "State": 1}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text); // Parse response
                                                            if (!resp.HasError) {
                                                                vthis.clearAll();
                                                                vthis.parse(
                                                                    resp.Data, // Parse data into combo
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo', // Combo box for activation status
                            label: _('Estado'),
                            name: 'State',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                            required: true, // Required field
                            options: [
                                {
                                    id: 'A',
                                    value: _('Activa'), // Localized value
                                },
                                {
                                    id: 'I',
                                    value: _('Inactiva'), // Localized value
                                },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            placeholder: _(
                                'Click para seleccionar ', // Placeholder text
                            ),
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide window on click
                                        $$('addformPB').setValues(
                                            $$('addformPB').getCleanValues(), // Reset form values
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        var values = $$('addformPB').getValues(); // Get form values
                                        var form = $$('addformPB');

                                        if (!form.validate()) {
                                            webix.message({ type: "error", text: _("Por favor, completa todos los campos obligatorios.") });
                                            return;
                                        }
                                        webix
                                            .ajax() // AJAX request to save new cryptoCurrency and blockchain association
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() +
                                                'CryptoNetworks/SaveBlockchainCryptoCurrency',
                                                '{"BlockchainIdNetwork":"' +
                                                values.BlockchainIdNetwork +
                                                '", "CryptoCurrencyId":"' +
                                                values.CryptoCurrencyId +
                                                '", "State":"' +
                                                values.State +
                                                '"}',
                                                {
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var resp = JSON.parse(text);
                                                        if(resp.HasError) {
                                                            return;
                                                        }else {
                                                            webix.message(
                                                                'Criptomoneda Red Blockchain Agregada', // Success message
                                                            );
                                                            grid.clearAll(); // Clear grid data
                                                            grid.load(
                                                                url +
                                                                '?start=0&count=' +
                                                                grid.data.$pagesize +
                                                                filter, // Reload grid data
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('addformPB').setValues(
                                            $$('addformPB').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Hide window after saving
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        this.on(this.app, 'addCryptoBlockchain:button', (filter) => {
            // Event listener for adding blockchainNetworks
            popupAdd.show(); // Show add blockchainNetwork popup
        });
        this.on(this.app, 'cryptosBlockchain:filter', (filterData) => {
            // Event listener for filtering blockchainNetworks
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object and non-empty values
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Event handler for item double click
            var item = this.getItem(id); // Get double-clicked item
            popup.show(); // Show edit popup
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
        $$('editform').bind($$('datatable')); // Bind edit form to datatable
    }
}

// FILE DOCUMENTED
